import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import UserList from './components/UserList';
import AddEditUser from './components/AddEditUser';
import Profile from './profile';
import ManageWorkload from './workloadManage';
import Toast from '../../Toast';
import {
    selectLoggedInUser,
    selectCurrentUser,
} from '_admin/features/users/usersSelectors';
import { jsonEncrypt, jsonDecrypt } from '@common/util';

const Users = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { userId: routeUserId, encrypted: routeEncryptedUserId } = useParams();
    const decryptedProfileUserId = routeEncryptedUserId ? jsonDecrypt(routeEncryptedUserId) : null;
    const loggedInUser = useSelector(selectLoggedInUser);
    const currentUser = useSelector(selectCurrentUser);
    const toast = useSelector((state) => state.toast);
    const handleCloseToast = () => dispatch({ type: 'HIDE_TOAST' });

    const [view, setView] = useState({ mode: 'list' });

    const loggedInUserId = currentUser?.id ?? loggedInUser?.UserId ?? null;

    const isAddRoute = location.pathname === '/users/add';
    const isEditRoute = location.pathname.startsWith('/users/edit/');
    const isProfileRoute = location.pathname.startsWith('/user-profile/');

    const handleAddUser = () => {
        navigate('/users/add');
    };

    const handleEditUser = (user) => {
        navigate(`/users/edit/${user.id}`);
    };

    const handleViewProfile = (user) => {
        navigate(`/user-profile/${jsonEncrypt(user.id)}`);
    };

    const handleBack = () => {
        navigate('/users');
    };

    const handleManageWorkload = (user, type) => {
        navigate(`/users/manageworkload/${user.id}?type=${type}`);
    };

    if (isAddRoute || isEditRoute) {
        return (
            <>
                {toast.show && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    delayTime={toast.delayTime}
                    show={toast.show}
                    iconType={toast.iconType}
                    autoClose={toast.autoClose}
                    showActions={false}
                    closeToast={handleCloseToast}
                />
                )}
                <AddEditUser
                    userId={isEditRoute ? routeUserId : null}
                    isEditMode={isEditRoute}
                    onClose={handleBack}
                />
            </>
        );
    }

    if (isProfileRoute) {
        return (
            <>
                {toast.show && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    delayTime={toast.delayTime}
                    show={toast.show}
                    iconType={toast.iconType}
                    autoClose={toast.autoClose}
                    showActions={false}
                    closeToast={handleCloseToast}
                />
                )}
                <Profile userId={decryptedProfileUserId} onClose={handleBack} />
            </>
        );
    }

    if (view.mode === 'manageWorkload') {
    return (
        <>
            {toast.show && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    delayTime={toast.delayTime}
                    show={toast.show}
                    iconType={toast.iconType}
                    autoClose={toast.autoClose}
                    showActions={false}
                    closeToast={handleCloseToast}
                />
            )}
            <ManageWorkload
                user={view.user}
                type={view.type}
                onBack={handleBack}
            />
        </>
    );
}

    return (
         <>
            {toast.show && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    delayTime={toast.delayTime}
                    show={toast.show}
                    iconType={toast.iconType}
                    autoClose={toast.autoClose}
                    showActions={false}
                    closeToast={handleCloseToast}
                />
            )}
            <UserList
                loggedInUserId={loggedInUserId}
                onAddUser={handleAddUser}
                onEditUser={handleEditUser}
                onViewProfile={handleViewProfile}
                onManageWorkload={handleManageWorkload}
            />
        </>
    );
};

export default Users;